import React, { useContext, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
    FaHome, FaUserNinja, FaWallet,
    FaCog, FaSignOutAlt, FaTimes, FaFileDownload,
    FaTv, FaUserShield, FaChevronDown
} from 'react-icons/fa';
import { AppContext } from '../../context/AppContext';

const ManagerSidebar = ({ isOpen, toggleSidebar, logout, isDesktop }) => {
    const location = useLocation();
    const { user } = useContext(AppContext);

    // State untuk mengontrol Dropdown / Submenu (collapse) pada mobile
    const [openMenus, setOpenMenus] = useState({});

    // Fungsi Toggle Menu (Untuk Mobile Click)
    const toggleMenu = (menuId) => {
        if (!isDesktop) {
            setOpenMenus(prev => ({ ...prev, [menuId]: !prev[menuId] }));
        }
    };

    const allMenuItems = [
        { id: 'dashboard', title: 'Dashboard', path: '/manager/dashboard', icon: <FaHome /> },
        { 
            id: 'atlet_saya_kyorugi', title: 'Atlet Kyorugi', icon: <FaUserNinja />,
            subMenus: [
                { title: 'Prestasi', path: '/manager/atlet/kyorugi/prestasi' },
                { title: 'Festival', path: '/manager/atlet/kyorugi/festival' }
            ]
        },
        { 
            id: 'atlet_saya_poomsae', title: 'Atlet Poomsae', icon: <FaUserNinja />,
            subMenus: [
                { title: 'Prestasi', path: '/manager/atlet/poomsae/prestasi' },
                { title: 'Festival', path: '/manager/atlet/poomsae/festival' }
            ]
        },
        { 
            id: 'live_monitor', title: 'Live Monitor', icon: <FaTv />, roles: ['manager'],
            subMenus: [
                { title: 'Prestasi', path: '/manager/live-paparan/prestasi' },
                { title: 'Festival', path: '/manager/live-paparan/festival' }
            ]
        },
        { id: 'pembayaran', title: 'Pembayaran', path: '/manager/pembayaran', icon: <FaWallet /> },
        { id: 'proposal', title: 'Download Proposal', path: '/manager/proposal', icon: <FaFileDownload /> },
        { id: 'tim', title: 'Profil Tim', path: '/manager/settings', icon: <FaCog /> },
        { id: 'keamanan', title: 'Keamanan Akun', path: '/manager/profile', icon: <FaUserShield /> },
    ];

    const menuItems = (user && user.is_verified === false)
        ? allMenuItems.filter(item => item.path === '/manager/profile')
        : allMenuItems;

    const sidebarTransform = isOpen ? 'translateX(0)' : 'translateX(-100%)';

    // Komponen helper untuk merender single link vs dropdown
    const renderMenuItem = (item) => {
        // Cek apakah item memiliki roles-restriction
        if (item.roles && !item.roles.includes(user?.role)) return null;

        // Cek apakah parent aktif (salah satu childnya sedang diakses)
        const isParentActive = item.subMenus?.some(sub => location.pathname.startsWith(sub.path)) || location.pathname === item.path;
        // Status terbuka dari State (mobile) atau CSS hover (desktop)
        const isOpenState = openMenus[item.id];

        if (item.subMenus) {
            // Render Dropdown
            return (
                <li key={item.id} className="nav-item dropdown-custom">
                    <div
                        className="nav-link d-flex align-items-center gap-3 text-white transition-all w-100"
                        style={{
                            borderRadius: '12px', padding: '12px 16px',
                            background: isParentActive ? 'rgba(255, 255, 255, 0.15)' : 'transparent',
                            boxShadow: isParentActive ? '0 4px 12px rgba(0,0,0,0.1)' : 'none',
                            fontWeight: isParentActive ? '700' : '500', opacity: isParentActive ? 1 : 0.8,
                            cursor: 'pointer'
                        }}
                        onClick={() => toggleMenu(item.id)}
                    >
                        <span style={{ fontSize: '1.2rem', width: '24px', display: 'flex', justifyContent: 'center' }}>{item.icon}</span>
                        <span>{item.title}</span>
                        <FaChevronDown className={`ms-auto transition-transform ${isOpenState ? 'rotate-180' : ''}`} style={{ fontSize: '12px' }} />
                    </div>

                    {/* Submenu Container */}
                    <div className={`submenu-collapse ${isOpenState ? 'show' : ''}`}>
                        <ul className="nav flex-column ms-4 ps-2 border-start border-white border-opacity-10 mt-1 gap-1">
                            {item.subMenus.map((sub, idx) => {
                                const isSubActive = location.pathname === sub.path;
                                return (
                                    <li className="nav-item" key={idx}>
                                        <Link 
                                            to={sub.path} 
                                            onClick={() => !isDesktop && toggleSidebar()}
                                            className={`nav-link text-white py-2 px-3 rounded-3 small ${isSubActive ? 'fw-bold' : 'text-white-50'}`}
                                            style={{
                                                background: isSubActive ? 'rgba(255,255,255,0.1)' : 'transparent',
                                                transition: 'background 0.2s'
                                            }}
                                            onMouseEnter={(e) => !isSubActive && (e.currentTarget.style.background = 'rgba(255, 255, 255, 0.05)')}
                                            onMouseLeave={(e) => !isSubActive && (e.currentTarget.style.background = 'transparent')}
                                        >
                                            {sub.title}
                                        </Link>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                </li>
            );
        }

        // Render Normal Link
        return (
            <li className="nav-item" key={item.id || item.title}>
                <Link
                    to={item.path}
                    className={`nav-link d-flex align-items-center gap-3 text-white transition-all`}
                    style={{
                        borderRadius: '12px', padding: '12px 16px',
                        background: isParentActive ? 'rgba(255, 255, 255, 0.15)' : 'transparent',
                        boxShadow: isParentActive ? '0 4px 12px rgba(0,0,0,0.1)' : 'none',
                        fontWeight: isParentActive ? '700' : '500', opacity: isParentActive ? 1 : 0.8
                    }}
                    onClick={() => !isDesktop && toggleSidebar()}
                    onMouseEnter={(e) => !isParentActive && (e.currentTarget.style.background = 'rgba(255, 255, 255, 0.05)')}
                    onMouseLeave={(e) => !isParentActive && (e.currentTarget.style.background = 'transparent')}
                >
                    <span style={{ fontSize: '1.2rem', width: '24px', display: 'flex', justifyContent: 'center' }}>{item.icon}</span>
                    <span>{item.title}</span>
                </Link>
            </li>
        );
    };

    return (
        <>
            {/* Mobile Overlay */}
            {!isDesktop && isOpen && (
                <div
                    className="position-fixed top-0 start-0 w-100 h-100 bg-dark"
                    style={{ opacity: 0.5, zIndex: 2 }}
                    onClick={toggleSidebar}
                ></div>
            )}

            {/* Sidebar - Tema Gelap */}
            <aside
                className={`position-fixed top-0 start-0 h-100 text-white d-flex flex-column z-3`}
                style={{
                    width: '260px',
                    background: 'linear-gradient(180deg, #312e81 0%, #1e1b4b 100%)', // Warna gelap asli
                    transform: sidebarTransform,
                    transition: 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                    boxShadow: '4px 0 24px rgba(0,0,0,0.1)',
                    zIndex: 1050
                }}
            >
                {/* Header Sidebar */}
                <div className="p-4 d-flex align-items-center justify-content-between border-bottom border-white border-opacity-10">
                    <Link to="/manager/dashboard" className="text-decoration-none d-flex align-items-center gap-3">
                        <div className="bg-white text-primary rounded p-2 d-flex align-items-center justify-content-center">
                            <FaUserNinja size={20} />
                        </div>
                        <h5 className="fw-bold m-0 text-white" style={{ letterSpacing: '1px' }}>MANAGER</h5>
                    </Link>
                    {!isDesktop && (
                        <button onClick={toggleSidebar} className="btn btn-sm btn-link text-white p-0">
                            <FaTimes size={20} />
                        </button>
                    )}
                </div>

                {/* Menu List */}
                <div className="flex-grow-1 overflow-auto p-3 custom-scrollbar">
                    <ul className="nav flex-column gap-2 pb-4">
                        {menuItems.map(renderMenuItem)}
                    </ul>
                </div>

                {/* Footer Logout */}
                <div className="p-3 border-top border-white border-opacity-10 mt-auto bg-black bg-opacity-25">
                    <button
                        onClick={logout}
                        className="btn w-100 d-flex align-items-center justify-content-center gap-2 text-white bg-danger bg-opacity-75 hover-scale shadow-sm"
                        style={{ borderRadius: '12px', padding: '12px', transition: 'all 0.2s', border: 'none' }}
                    >
                        <FaSignOutAlt /> Keluar
                    </button>
                </div>

                {/* CSS Khusus Sidebar */}
                <style>{`
                    .hover-scale { transition: transform 0.2s; }
                    .hover-scale:hover { transform: scale(1.02); }
                    .custom-scrollbar::-webkit-scrollbar { width: 4px; }
                    .custom-scrollbar::-webkit-scrollbar-track { background: transparent; }
                    .custom-scrollbar::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.2); border-radius: 10px; }
                    .custom-scrollbar::-webkit-scrollbar-thumb:hover { background: rgba(255,255,255,0.4); }

                    /* Logika Collapse */
                    .submenu-collapse {
                        max-height: 0;
                        overflow: hidden;
                        transition: max-height 0.3s ease-in-out;
                    }
                    .submenu-collapse.show {
                        max-height: 200px;
                    }
                    .transition-transform { transition: transform 0.3s ease; }
                    .rotate-180 { transform: rotate(180deg); }

                    /* Hover otomatis hanya di Desktop (>= 992px) */
                    @media (min-width: 992px) {
                        .dropdown-custom:hover .submenu-collapse {
                            max-height: 200px;
                        }
                        .dropdown-custom:hover .rotate-180 {
                            transform: rotate(180deg);
                        }
                    }
                `}</style>
            </aside>
        </>
    );
};

export default ManagerSidebar;